<template>
    <div class="gis_map_maindiv">
        <!--url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"-->
        <l-map class="gis_map_fullscreen" ref="map" :zoom="5" :center="[47.41322, -1.219482]" :bounds="allCoordinates">
            <l-tile-layer
                url="https://api.maptiler.com/maps/satellite/256/{z}/{x}/{y}.jpg?key=HjiIG1alkJRG2oDoScNH"
                layer-type="base"
                name="Satellite"
            ></l-tile-layer>
            <l-tile-layer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                layer-type="base"
                name="OpenStreetMap"
            ></l-tile-layer>
            <l-control-layers
                position="bottomleft"
            />
            <l-polygon
                v-for="pol in polygons"
                :key="pol.id"
                :lat-lngs="pol.coords"
                :color="pol.color"
                :fill="pol.fill"
                :fillOpacity="pol.fillOpacity"
                :fillColor="pol.fillColor"
                :width="pol.strokeWidth"
            />
            <l-marker
                v-for="pop in popups"
                :key="pop.id"
                :lat-lng="pop.coords"
            >
                <l-popup>{{ pop.content }}</l-popup>
            </l-marker>
        </l-map>
        <div v-show="alertText != ''" class="text_alert">
            <div style="background: white;">
                <p style="padding: 0.5vw;">Выбрано: {{ alertText }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { LMarker, LMap, LPolygon, LPopup, LTileLayer, LControlLayers } from "@vue-leaflet/vue-leaflet";
import tools from '@/assets/js/tools.js';

export default {
    name: 'MapShowcase',
    props: {
        addresses: Array,
    },
    components: {
        LMarker,
        LMap,
        LPolygon,
        LPopup,
        LTileLayer,
        LControlLayers,
    },
    data: function() {
        return {
            allCoordinates: [],
            polygons: [],
            popups: [],
            alertText: "",
            tools: tools,
        }
    },
    methods: {
        async geocodeAddress(address) {
            const TOKEN = "27b21cb1-37db-439a-8c9a-c27cd5f06f29";
            try {
                if (address != undefined) {
                    const response = await fetch(
                        `https://catalog.api.2gis.com/3.0/items/geocode?q=${address}&fields=items.point&key=${TOKEN}`
                    );
                    if (!response.ok) {
                        throw new Error(`Failed to geocode address: ${response.statusText}`);
                    }
                    const data = await response.json();
                    const point = data.result && data.result.items[0]?.point;
                    if (!point) {
                        throw new Error('No coordinates found for the provided address.');
                    }
                    return point;
                }
            } catch (error) {
                console.error(error);
                throw new Error('Failed to geocode address.');
            }
        },
        async getMarkers() {
            return Promise.all(this.addresses.map(async (address) => {
                //return await this.geocodeAddress(address);
                var coords = tools.extractPoint(address);
                return await (new Promise((succ) =>
                    setTimeout(() => succ(coords), 500)
                ));
            }));
        },
    },
    mounted() {
        var vm = this;
        vm.getMarkers().then(coordinates => {
            vm.allCoordinates = coordinates;
            for (var i in vm.allCoordinates) {
                var addressType = "Промежуточный адрес, ";
                if (i == 0) {
                    addressType = "Начальный адрес, ";
                } else if (i == vm.allCoordinates.length - 1) {
                    addressType = "Конечный адрес, ";
                }
                vm.popups.push({
                    id: vm.popups.length,
                    coords: vm.allCoordinates[i],
                    content: addressType + vm.addresses[i]
                });
            }
        });
    }
}
</script>

<style lang="css" scoped src="@/assets/css/gis_map.css"></style>
